import { useResource } from 'hooks/useResource';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FormCheckData from '../forms/FormCheckData';
import LayoutAgendaSteps from './LayoutAgendaSteps';

export default function PageCreateAgendaCheckData() {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();
  const { data: agenda } = useResource({ id, resourceName: 'agenda', path: 'agendas' });

  if (agenda && agenda.email)
    navigate(`/disparos-de-agenda${location.search}`)
  
  return (
    <LayoutAgendaSteps activeStepIndex={2}>
      { agenda && <FormCheckData agenda={agenda} /> }
    </LayoutAgendaSteps>
  );
}
